import React from 'react';
import { CategoriesMenu, MAIN_WRAPPER_CLASSNAME } from '@fiverr-private/categories_menu';

type CategoriesMenuProps = Exclude<Parameters<typeof CategoriesMenu>[0], 'children'>;

const CategoriesMenuWrapper = (props: CategoriesMenuProps) => (
    <div className={MAIN_WRAPPER_CLASSNAME}>
        <CategoriesMenu {...props} />
    </div>
);

export default CategoriesMenuWrapper;
